import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

const RATIO = 0.074;

export const IconUnlock = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "2px", ...props }, ref) => {
    // In this icon we use stroke instead of fill
    const currentStroke = isNumber(size) ? `${size * RATIO}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 13.3333C5 11.6764 6.34314 10.3333 8 10.3333H16C17.6569 10.3333 19 11.6764 19 13.3333V16.6666C19 18.3234 17.6569 19.6666 16 19.6666H8C6.34315 19.6666 5 18.3234 5 16.6666V13.3333ZM8 12.3333C7.44772 12.3333 7 12.781 7 13.3333V16.6666C7 17.2189 7.44772 17.6666 8 17.6666H16C16.5523 17.6666 17 17.2189 17 16.6666V13.3333C17 12.781 16.5523 12.3333 16 12.3333H8Z"
          fill="currentColor"
        />
        <path
          d="M8.66651 11.3334V8.66671C8.66478 6.9542 9.961 5.51901 11.6648 5.3469C13.3687 5.1748 14.9257 6.32178 15.2665 8.00004"
          stroke="currentColor"
          strokeWidth={currentStroke}
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
